import React from 'react';
import LegalPage from '../components/LegalPage';
import PoliticasDePrivacidadContent from '../components/PoliticasDePrivacidadContent';

const PoliticasDePrivacidad: React.FC = () => (
  <LegalPage
    title="Política de Privacidad"
    lastUpdated="5 de junio de 2026"
    backHref="/"
  >
    <PoliticasDePrivacidadContent />
  </LegalPage>
);

export default PoliticasDePrivacidad;
